import * as React from "react";
import { API } from "../API";
import { ApiWithRetry } from "../ExponentialBackOffNetworkRequest";
import { isLoading, Loading, loading } from "../Loading";
import { CaregiverAvailability, NullableCaregiverAvailability } from "../messages/Caregiver";
import { Intent, Spinner } from "@blueprintjs/core";
import { CaregiverAvailabilityScreen } from "../components/placeholders/CaregiverAvailabillityScreen";
import { HRAvailabilityPlaceholderSettings } from "../messages";

interface CaregiverAvailabilityActivityProps {
    api: API;
    settings: HRAvailabilityPlaceholderSettings | null;
}

interface CaregiverAvailabilityActivityState {
    availability: CaregiverAvailability | Loading;
}

function generateDefaultInitAvailability(): CaregiverAvailability {
    return {
        dayAvailabilities: [
            {
                day: 0,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 1,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 2,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 3,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 4,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 5,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            },
            {
                day: 6,
                startHour: 0,
                endHour: 24,
                busyAllDay: false
            }
        ],
        minDuration: 1,
        maxDuration: 24,
        maxDistance: 99
    };
}

export class CaregiverAvailabilityActivity extends React.Component<CaregiverAvailabilityActivityProps, CaregiverAvailabilityActivityState> {
    constructor(props: CaregiverAvailabilityActivityProps) {
        super(props);

        this.state = {
            availability: loading()
        };

        this.getInitialAvailabilities();
    }

    private caregiverAvailabilityRequest = new ApiWithRetry();

    componentWillUnmount() {
        this.caregiverAvailabilityRequest.cancel();
    }

    async getInitialAvailabilities() {
        const storedAvailabilityWrapper: NullableCaregiverAvailability | null = await this.caregiverAvailabilityRequest.fetch(() => this.props.api.getCaregiverAvailability());

        if (storedAvailabilityWrapper === null) {
            return;
        }

        const storedAvailability = storedAvailabilityWrapper.caregiverAvailability;
        if (storedAvailability === null) {
            this.setState({
                availability: generateDefaultInitAvailability()
            });
        } else {
            this.setState({
                availability: storedAvailability
            });
        }
    }

    async handleBlur(dayAvailabilities: CaregiverAvailability): Promise<void> {
        // TODO exponential backoff
        return await this.props.api.setCaregiverAvailability(dayAvailabilities);
    }

    render() {
        if (isLoading(this.state.availability)) {
            return (
                <Spinner intent={Intent.PRIMARY}/>
            );
        } else {
            return (
                <CaregiverAvailabilityScreen
                    initialCaregiverAvailability={this.state.availability}
                    onBlur={(avail: CaregiverAvailability) => this.handleBlur(avail)}
                    settings={this.props.settings}
                />
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/activities/CaregiverAvailabillityActivity.tsx